import React from 'react';
import { arrayOf, object } from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import RecurringOptionDiscount from '../../../../../shared/RecurringOptionDiscount';
import { getRecurringOptions } from '../../../../../../reducers/packages';
import SingleOrderPlanRadio from './SingleOrderPlanRadio';
import RecurringOrderPlanRadio from './RecurringOrderPlanRadio';

import './style.scss';

const CheckoutPlanSelect = ({ recurringOptions }) => {
    const isSingleOption = recurringOptions.length === 1;

    const wrapperClass = classNames(
        'checkout-plan-select',
        { 'single-option': isSingleOption }
    );

    return (
        <div className={wrapperClass}>
            <SingleOrderPlanRadio/>
            <RecurringOrderPlanRadio/>
            <RecurringOptionDiscount/>
        </div>
    );
};

CheckoutPlanSelect.propTypes = {
    recurringOptions: arrayOf(object)
};

const mapStateToProps = ({ packages }) => {
    const recurringOptions = getRecurringOptions(packages);

    return { recurringOptions };
};

export { CheckoutPlanSelect };
export default connect(mapStateToProps)(CheckoutPlanSelect);
